import { debounce } from 'lodash-es';
import { ChildCareSubtype, CommonDataPublisher } from '@care/mfe-data-transfer-common';
import { CLIENT_FEATURE_FLAGS } from '@/constants';
import { useSeekerCCState, useSeekerState } from '../AppState';
import { useFeatureFlags } from '../FeatureFlagsContext';

export const useCommonSharedData = () => {
  const featureFlags = useFeatureFlags();
  const { zipcode, city, state } = useSeekerState();
  const { careChildrenDOB, careKind } = useSeekerCCState();
  const isEligibleForPublish =
    featureFlags?.flags[CLIENT_FEATURE_FLAGS.PROJECT_GREAT_MIGRATION_SESSION_STORAGE]?.value;
  // Condition to prevent populating storage with initial, empty values
  const isUserDataEntered = Boolean(zipcode && city && state);

  const setCommonSharedData = () => {
    if (isEligibleForPublish && isUserDataEntered) {
      const childCareSubtype = careKind as any as ChildCareSubtype;
      const CommonPublisher = new CommonDataPublisher();
      CommonPublisher.publishData({
        zipcodeData: {
          zipcode,
          state,
          city,
        },
        childCareJob: {
          careChildrenDOB,
          childCareSubtype,
        },
      });
    }
  };

  const publishCommonSharedData = debounce(setCommonSharedData, 500, {
    leading: true,
    trailing: true,
    maxWait: 1000,
  });

  return { publishCommonSharedData };
};
